import { toast } from "sonner";
import request from "../../../helpers/request";
import { IPostConfigPtMonMedidor } from "./types";

const DTO = (data: IPostConfigPtMonMedidor) => {
  const {
    idLoja,
    idEquipamento,
    idGrupoMonitor,
    valor,
    diaMedicao,
    limiteSup,
    limiteInf,
    coordX,
    coordY,
    offSet,
    calibracaoEscala,
    hrMsgEscaladaNV2,
    minMsgEscaladaNV2,
    hrMsgEscaladaNV3,
    minMsgEscaladaNV3,
  } = data;

  const checkDataEscalada = (data) => (!data ? "00" : data);

  return {
    ...data,
    idLoja: Number(idLoja),
    idEquipamento: Number(idEquipamento),
    idGrupoMonitor: Number(idGrupoMonitor),
    valor: Number(valor),
    diaMedicao: Number(diaMedicao),
    limiteSup: Number(limiteSup),
    limiteInf: Number(limiteInf),
    coordX: Number(coordX),
    coordY: Number(coordY),
    offSet: Number(offSet),
    calibracaoEscala: Number(calibracaoEscala),
    timeMsgEscaladaNV2: `${checkDataEscalada(
      hrMsgEscaladaNV2,
    )}:${checkDataEscalada(minMsgEscaladaNV2)}`,
    timeMsgEscaladaNV3: `${checkDataEscalada(
      hrMsgEscaladaNV3,
    )}:${checkDataEscalada(minMsgEscaladaNV3)}`,
    msgFalhaAcimaCustom: "",
    msgFalhaAbaixoCustom: "",
    msgNormalCustom: "",
  };
};

export const postConfigPtMonMedidor = async (
  props: IPostConfigPtMonMedidor,
) => {
  try {
    const url = `${process.env.REACT_APP_API}/MonMedidor`;
    const data = DTO({
      ...props,
      valor: 0,
    });

    delete data.hrMsgEscaladaNV2;
    delete data.minMsgEscaladaNV2;
    delete data.hrMsgEscaladaNV3;
    delete data.minMsgEscaladaNV3;

    const result = await request({
      url,
      method: "post",
      data,
      headers: { "Content-Type": "application/json" },
    });

    if (result.data.toLowerCase() === "ok") {
      toast.success("Configuração realizada com sucesso!");
      return result.data;
    } else {
      throw new Error(result.data);
    }
  } catch (error: any) {
    const apiError = error.response?.data;

    if (process.env.NODE_ENV === "development") {
      console.error("Datalhes do Erro:", apiError);
    }

    let mensagemExibicao = "Erro ao processar a requisição.";

    if (apiError?.errors) {
      const detalhes = Object.values(apiError.errors).flat().join(" | ");
      mensagemExibicao = detalhes;
    } else if (apiError?.title) {
      mensagemExibicao = apiError.title;
    }

    toast.error(mensagemExibicao, {
      description: "Verifique os campos e tente novamente.",
    });
  }
};
